module.exports = __webpack_public_path__ + "img/8.02112e40.webp";